import * as D from '../../def';
export const annotation:D.IAnnotation = {
  circle: {
    pricePoints: [
      {
        color: 'red',
        date: {
          year: 2021,
          month: 4,
          day: 21,
        },
      },
      {
        color: 'green',
        date: {
          year: 2021,
          month: 5,
          day: 21,
        },
      },
      {
        color: 'red',
        date: {
          year: 2021,
          month: 6,
          day: 21,
        },
      },
    ],
    IndicePoints: [
      {
        color: 'green',
        date: {
          year: 2021,
          month: 4,
          day: 21,
        },
      },
      {
        color: 'red',
        date: {
          year: 2021,
          month: 5,
          day: 21,
        },
      },
      {
        color: 'red',
        date: {
          year: 2021,
          month: 6,
          day: 21,
        },
      },
    ],
  },
};
